import * as GC from '@mescius/spread-sheets';

import { isRangeIntersectingAnyLoop } from './loop';
import { translate } from './translations';

/**
 * clipboardが変更された時とペーストに対するハンドラー
 */
export function registerClipboardChangeAndPasteHandler(
  spread: GC.Spread.Sheets.Workbook,
  alert: (message: string) => void
): void {
  spread.bind(
    GC.Spread.Sheets.Events.ClipboardChanging,
    (
      _e: unknown,
      args: GC.Spread.Sheets.IClipboardChangingEventArgs & {
        ranges: GC.Spread.Sheets.Range[];
      }
    ): void => {
      const { ranges, sheet } = args;
      if (!sheet) return;

      if (ranges.length === 0) return;

      if (ranges.some((range) => isRangeIntersectingAnyLoop(sheet, range))) {
        args.cancel = true;
        alert(translate('COPY_SOURCE_CONTAINS_LOOP_RANGE'));
        return;
      }
    }
  );

  spread.bind(
    GC.Spread.Sheets.Events.ClipboardPasting,
    (
      _e: unknown,
      args: GC.Spread.Sheets.IClipboardPastingEventArgs & {
        cellRange: GC.Spread.Sheets.Range;
      }
    ): void => {
      const { cellRange, sheet } = args;
      if (!sheet) return;

      if (isRangeIntersectingAnyLoop(sheet, cellRange)) {
        args.cancel = true;
        alert(translate('PASTE_TARGET_CONTAINS_LOOP_RANGE'));
        return;
      }
    }
  );
}
